import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Pasaré hambre?',
    a: 'No, comerás alimentos densos en nutrientes que te mantendrán satisfecha. El objetivo es nutrir, no restringir.'
  }, {
    q: '¿Es difícil de seguir?',
    a: 'Está diseñado para mujeres ocupadas. Las recetas son simples y los ingredientes se encuentran en cualquier tienda.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No son obligatorios, te recomendamos opciones naturales que probablemente ya tienes en tu cocina.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream py-20 px-4" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <FadeIn data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-49">
            Preguntas <span className="italic text-terracotta" data-id="element-50">Frecuentes</span>
          </h2>

          <div className="space-y-4" data-id="element-51">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border border-beige overflow-hidden" data-id="element-52">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta" aria-expanded={openIndex === index} data-id="element-53">
                  <span className="font-bold text-brown-dark text-lg" data-id="element-54">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
                </button>
                <AnimatePresence data-id="element-56">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-57">
                      <div className="px-6 pb-5 text-brown-body" data-id="element-58">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}